<template>
	<div>
	  <page-heading-info
    title="Jefferson County Interesting Facts"
    courthouse="true"
    ></page-heading-info>

		<div style="padding-left: 15px; padding-right: 15px;">

      <div class="row mt-3">
        <div class="col-md-6 bg-grey-02 p-3">
          <div style="font-size: 1.25em; line-height: 1.75em;">
          We now have 64,581 parcels with a total market value of 4,886,686,499 dollars. This generates approximately 
          <strong>$90,617,554.18</strong> per year in property tax which is distributed to our local schools, townships, 
          cities, villages, and county government.
          </div>

          <hr />

            <p class="mt-3">
              &#9679; Of these 64,581 parcels, approximately:
              <ul class="reg mt-3 text-primary bg-grey-02 text-bold">
                <li>68% are classed as Residential</li>
                <li>8% Agricultural</li>
                <li>9% Exempt</li>
                <li>6% Commercial</li>
                <li>1% Industrial</li>
                <li>8% Minerals</li>
              </ul>
            </p>
            <p>
              &#9679; Of the 64,581 parcels: 34,379 have improvements on them.
            </p>
            <p>
              &#9679; 28,547 dwellings exist in the county of which 5,714 receive homestead reduction savings.
            </p>
            <p>
              &#9679; Jefferson County has 159,624 acres of mineral land currently being taxed.
            </p>
        </div>
        <div class="col-md-6">
          <table class="table">
            <tr style="font-weight: bold;">
              <td>Class</td><td>Count</td><td>Acres</td>
            </tr>
            <tr>
              <td>Agricultural</td><td>5,242</td><td>192,802.96</td>
            </tr>
            <tr>
              <td>Commercial</td><td>3,611</td><td>6,665.53</td>
            </tr>
            <tr>
              <td>Exempt</td><td>5,973</td><td>24,122.09</td>
            </tr>
            <tr>
              <td>Industrial</td><td>700</td><td>700 10,398.26</td>
            </tr>
            <tr>
              <td>Mineral</td><td>4,970</td><td>159,624.46</td>
            </tr>
            <tr> 
              <td>Public Util.</td><td>664</td><td>42.68</td>
            </tr>
            <tr>
              <td>Residential</td><td>43,421</td><td>30,038.05</td>
            </tr>
          </table>
        </div>
      </div>

      <hr />

      <div class="row mt-3">
        <div class="col-md-6 bg-primary-02 p-3" style="border-right 1px solid;">
          <!--
          <ul style="padding-left: 8px;">
            <li>
              Of these 64,581 parcels, approximately:
              <ul class="reg mt-3 text-primary bg-grey-02 text-bold">
                <li>68% are classed as Residential</li>
                <li>8% Agricultural</li>
                <li>9% Exempt</li>
                <li>6% Commercial</li>
                <li>1% Industrial</li>
                <li>8% Minerals</li>
              </ul>
            </li>
            <li>
              Of the 64,581 parcels: 34,379 have improvements on them.
            </li>
            <li>
              28,547 dwellings exist in the county of which 5,714 receive homestead reduction savings.
            </li>
            <li>
              Jefferson County has 159,624 acres of mineral land currently being taxed.
            </li>
          </ul>
          -->
          <h4 class=" text-underline">Highest &amp; Largest</h4>
            <p class="mt-3">
              The highest elevation in our county is 1,388 feet in the Northwest corner of Brush Creek Township. 
              At one time it was where our county water tower sits on State Route 43 in Island Creek Township. But when the 
              land was strip-mined for coal & the water tower was erected, the elevation of the land was lowered.
            </p>
            <p>
              Our largest house in the county resides in SMITHFIELD TWP coming in at a whopping 12,871 square feet of living space.
            </p>
            <p>
              The largest commercial--industrial structure is the Walmart Distribution Center located on SR43 with 869,435 
              square feet. The second largest structure is the Fort Steuben Mall coming in at 265,296 square feet.
            </p>
        </div>
        <div class="col-md-6 bg-jeff-yellow-02 p-3">

            <h4 class=" text-underline">Top 10 Taxpayers in Order</h4>
            <ul style="padding-left: 22px;" class="mt-3">
              <li>Ascent Resources Utica LLC</li>
              <li>Ohio Power Company</li>
              <li>Texas Eastern Transmission LP</li>
              <li>Rover Pipeline LLC</li>
              <li>Buckeye Electric Utility</li>
              <li>EAP Ohio LLC</li>
              <li>American Transmission Systems Inc.</li>
              <li>Energy Harbor Generation LLC</li>
              <li>Ohio Edison Co.</li>
              <li>Columbia Gas of Ohio Inc. Tax Dept.</li>
            </ul>
        </div>
      </div>

    </div>
	</div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'

export default {
	components: {
		PageHeadingInfo,
    TextBoxTitle
	},
  data () {
    return {}
  },
  props: [],
  mounted: function() {
    //called on launch
  },
  methods: {}
}

</script>

<style scoped>
  ul li {
    padding-bottom: 12px;
  }

  .reg li {
    padding-bottom: 6px;
  }
</style>